import React from 'react';
import axios from 'axios';
import Comment from './Comment';
import Emoji from './../Partials/Emoji';

class CommentsForm extends React.Component {
    constructor(props) {
        super(props);

        this.id = `${props.post.id}_${props.replyTo?.id ?? 'first'}`;

        this.remember = this.getRememberCookie();

        this.state = {
            author_name: this.remember.author_name || '',
            author_email: this.remember.author_email || '',
            author_url: this.remember.author_url || '',
            comment_body: '',
            isSubmitted: false,
            isLoading: false,
            newComment: false,
        }

        this.onChangeValue = this.onChangeValue.bind(this);
        this.onRememberChange = this.onRememberChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.postStatusEnum = {
            publish: 'publish',
            spam: 'spam',
            approval: 'in_approval'
        };

        this.postStatusNotApprovedEnum = [
            this.postStatusEnum.approval,
            this.postStatusEnum.spam
        ];
    }

    onChangeValue(e) {
        const type = e.target.type;

        // Reset validation error
        e.target.classList.remove('is-invalid');

        switch (type) {
            case 'checkbox':
                this.setState({
                    [e.target.name]: e.target.checked
                });
                break;
            case 'textarea':
                this.setState({
                    commentBodyLength: e.target.value.length,
                    [e.target.name]: e.target.value
                });
                break;
        
            default:
                this.setState({
                    [e.target.name]: e.target.value
                });
                break;
        }
    }

    getRememberCookie() {
        let rememberJSON = window.Cookie.get('comment_remember');
        if (typeof rememberJSON == 'undefined') {
            return false;
        }
        return JSON.parse(rememberJSON);
    }

    onRememberChange(e) {
        if (e.target.checked) {
            this.updateRemember();
        } else {
            window.Cookie.remove('comment_remember');
        }
    }

    updateRemember() {
        window.Cookie.set('comment_remember', JSON.stringify({
            author_name: this.state.author_name, 
            author_email: this.state.author_email, 
            author_url: this.state.author_url, 
        }), { expires: (365 * 10) });
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.remember) {
            this.updateRemember();
        }

        // Validate
        if (this.validate()) {
            // Post the comment
            this.postComment();
        }

    }

    validate() {
        let errors = [];

        if (this.state.comment_body.length < 1) {
            errors.push('comment_body');
        }

        // If not logged in
        if (!window.isLoggedIn) {
            if (this.state.author_name.length < 1) {
                errors.push('author_name');
            }
            
            if (this.state.author_email.length < 1 || !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(String(this.state.author_email).toLowerCase())) {
                errors.push('author_email');
            }

            if (this.state.author_url.length > 0 && !/^(\@\w+|(https?:\/\/)?([\w\-\/]+\.)+[\w\-\/]+$)/.test(this.state.author_url)) {
                errors.push('author_url');
            }
        }

        // Mark error inputs
        errors.forEach((name) => {
            const input = document.querySelector(`#comment_form_${this.id} [name="${name}"]`);
            input.classList.add('is-invalid');
        });

        return !errors.length > 0;
    }

    postComment() {
        this.loggedIn = window.Cookie.get('aller_blogger_platform_session') != null;

        this.setState({
            isLoading: true,
        });

        axios.post('/api/comment/store/', {
            post_id: this.props.post.id,
            comment_id: this.props.replyTo ? this.props.replyTo.id : null,
            author_name: this.state.author_name,
            author_email: this.state.author_email,
            author_url: this.state.author_url,
            comment_body: this.state.comment_body,
        })
        .then((response) => {
            this.setState({
                isSubmitted: true,
                isLoading: false,
                author_name: '',
                author_email: '',
                author_url: '',
                comment_body: '',
                newComment: response.data.comment,
            });

            if(response.data.comment.status == this.postStatusEnum.publish) {
                this.props.onFetchComments(); // Save for later, as we might need this again here
            }

            setTimeout(() => {
                this.setState({
                    isSubmitted: false
                });
            }, 10000);
        })
        .catch((error) => {
            const errorBag = error?.response?.data?.errors ?? null;
            
            if (errorBag !== null) {
                // Show first error.
                this.setState({
                    error: Object.values(errorBag)[0][0],
                    isLoading: false
                });   

                setTimeout(() => {
                    this.setState({
                        isSubmitted: false,
                        error: false
                    });
                }, 10000);
            }
        });
    }

    render() {
        const commentOnText = this.props.replyTo ? this.props.replyTo.author_name : this.props.post.title;

        return (
            <React.Fragment>

                { this.state.error && (
                    <p className="mb-0 comment--approval-message fadeout-5-5">{this.state.error}</p>
                )}
                { this.state.isSubmitted && this.postStatusNotApprovedEnum.indexOf(this.state.newComment.status) !== -1 && (
                    <p className="mb-0 comment--approval-message fadeout-5-5">{trans('Your comment has been submitted! Pending approval.')}</p>
                )} 
                {!this.state.newComment && (
                    <form id={`comment_form_${this.id}`} className={"comments__form" + (this.props.replyTo ? " comments__form--reply" : '')} onSubmit={this.onSubmit}>
                        <h4 className="comments__form__title">
                            Kommentera: {commentOnText}
                        </h4>

                        <div className="form-group">
                            <textarea name="comment_body" cols="10" rows="4" className="form-control" placeholder="Vad tycker du?" value={this.state.comment_body} onChange={this.onChangeValue} />
                            <div className="invalid-feedback">Skriv in en kommentar</div>
                            <p className='comments-body--count'>{this.state.commentBodyLength ?? 0}/5000</p>
                        </div>

                        { !window.isLoggedIn && 
                            <React.Fragment>
                                <div className="form-group">
                                    <input type="text" name="author_name" className="form-control" placeholder="Namn" value={this.state.author_name} onChange={this.onChangeValue} />
                                    <div className="invalid-feedback">Du måste ange ett namn</div>
                                </div>

                                <div className="form-group">
                                    <input type="text" name="author_email" className="form-control" placeholder="E-post" value={this.state.author_email} onChange={this.onChangeValue} />
                                    <div className="invalid-feedback">Ange en giltig e-postadress</div>
                                </div>

                                <div className="form-group">
                                    <input type="text" name="author_url" className="form-control" placeholder="Blogg/Instagram" value={this.state.author_url} onChange={this.onChangeValue} />
                                    <div className="invalid-feedback">Ange en giltig URL eller instagram tag (@konto)</div>
                                </div>
                            </React.Fragment>
                        }

                        <div className="form-group">
                            { !window.isLoggedIn && 
                                <div className="form-check">
                                    <input type="checkbox" id={`comment_form_${this.id}_remember`} name="remember" className="form-check-input" onChange={this.onRememberChange} defaultChecked={this.remember} />
                                    <label className="form-check-label" htmlFor={`comment_form_${this.id}_remember`}>Spara mitt namn och E-post i den här webbläsaren till nästa gång jag kommenterar.</label>
                                </div>
                            }

                            {/* <div className="form-check">
                                <input type="checkbox" id={`comment_form_${this.id}_notify`} name="notify" className="form-check-input" />
                                <label className="form-check-label" htmlFor={`comment_form_${this.id}_notify`}>Notifiera mig när jag får svar</label>
                            </div> */}
                        </div>

                        <div className="form-group clearfix">
                            <input type="submit" 
                                className="btn btn-primary" 
                                value={this.state.isLoading ? "Loading" : "Skicka kommentar"} 
                                disabled={(this.state.isLoading) ? 'disabled' : ''} />
                            { !this.state.isLoading && this.props.replyTo && 
                                <a  rel="nofollow"
                                    id={`cancel-comment-reply-link-${this.id}`}
                                    href={`https://${window.location.host}${this.props.post.url}#respond`}
                                    className="btn btn-light ml-4" 
                                    value={"Avbryt"}
                                    onClick={this.props.onToggleForm}>{"Avbryt"}</a>
                            }
                        </div>
                    </form>
                )}
            </React.Fragment>
        )
    }
}

export default CommentsForm;